import styled from "styled-components";

export const StyledFrame = styled.div`
  img {
    width: 30%;
    /* margin-left: -650px; */
    position: absolute;
    top: 16%;
    right: 21%;
  }
`;

export const GenderFrame = styled.div`
  width: 283px;
  height: 283px;
  background-color: #ffc542;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 25%);
`;
